import styles from "./player-controls.module.css";

export const PlayerContainer = "div";
export const PlayerContainerClassName = styles.playerContainer;

export const TopControls = "div";
export const TopControlsClassName = styles.topControls;

export const ControlsBottom = "div";
export const ControlsBottomClassName = styles.controlsBottom;

export const ControlsContainer = "div";
export const ControlsContainerClassName = styles.controlsContainer;

export const ControlsRow = "div";
export const ControlsRowClassName = styles.controlsRow;

export const ControlsSection = "div";
export const ControlsSectionClassName = styles.controlsSection;

export const ControlsSectionStart = "div";
export const ControlsSectionStartClassName = `${styles.controlsSection} ${styles.controlsSectionStart}`;

export const ControlsSectionEnd = "div";
export const ControlsSectionEndClassName = `${styles.controlsSection} ${styles.controlsSectionEnd}`;
